import { makeAutoObservable } from "mobx";
import { PackageInfoType, TeamInfoType } from "./interface";
import { teamDetailApi, teamPackageList } from "@/services/team";
import dayjs from "dayjs";
class TeamStore {
  // 团队信息
  teamInfo: TeamInfoType = {};
  // 套餐信息
  packageInfo: PackageInfoType = {
    packageTypeList: [],
    packageList: [],
  };

  constructor() {
    makeAutoObservable(this);
  }

  /** @description 改变团队信息 */
  setTeamInfo(info: TeamInfoType) {
    this.teamInfo = info;
  }
  /** @description 改变套餐信息 */
  setPackageInfo(info: PackageInfoType) {
    this.packageInfo = info;
  }

  /** @description 获取团队信息 */
  async getTeamInfo() {
    // 获取团队信息
    const detail_res = await teamDetailApi();
    if (detail_res.data?.code === 0) {
      const { item = {} } = detail_res.data?.data || {};
      this.setTeamInfo({
        ...item,
        create_time: item?.created_at ? dayjs.unix(item?.created_at).format("YYYY-MM-DD") : "-",
      });
    }
  }
  /** @description 获取套餐信息 */
  async getPackageInfo() {
    // 获取套餐信息
    const package_res = await teamPackageList({ state: 3, product: 4 });
    if (package_res.data?.code === 0) {
      const { infos = [], items = [] } = package_res.data?.data || {};
      const packageTypeList = infos;
      const packageList = items.map((item) => ({
        ...item,
        expires_time: item?.expires_at ? dayjs.unix(item?.expires_at).format("YYYY-MM-DD") : "-",
      }));
      this.setPackageInfo({ packageTypeList, packageList });
    }
  }
}

const teamStore = new TeamStore();

export default teamStore;
